/**
 * SHER-224 — resolve the title shown under a PDF signature.
 *
 * The signature footer used to hard-code "Médecin Prescripteur" for every
 * uploader, mislabelling non-clinical staff (admins, secretaries) as
 * physicians — a medico-legal misrepresentation. The title now reflects the
 * uploader's actual investigation role:
 *   - a known role → its i18n display name (investigation.share.roles.<ROLE>)
 *   - a custom role with no translation → its raw name
 *   - no/unknown role → null, so the caller omits the title line entirely
 *     (the signature then shows just the name, never a false clinical title).
 */
export function resolveRoleTitle(
    roleName: string | null | undefined,
    t: (key: string) => string,
): string | null {
    if (!roleName) {
        return null;
    }
    const key = 'investigation.share.roles.' + roleName;
    const translated = t(key);
    // createT (simpleTranslate) returns the key itself when no entry exists.
    return translated && translated !== key ? translated : roleName;
}
